import { Dispatch, SetStateAction, useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import {
    Modal,
    Button,
    Select,
    MenuItem,
    SelectChangeEvent,
    Checkbox,
    FormControlLabel,
} from "@mui/material";

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function AddZone({ open, onClose, setOpen }: ModalProps) {
    const [zoneType, setZoneType] = useState("City");
    const [unit, setUnit] = useState("Days");
    const [active, setActive] = useState(true);

    const handleZoneTypeChange = (event: SelectChangeEvent) => {
        setZoneType(event.target.value);
    };

    const handleUnitChange = (event: SelectChangeEvent) => {
        setUnit(event.target.value);
    };

    return (
        <Modal className="modal rejectReason_modal" open={open} onClose={onClose}>
            <div className="modal-dialog take_action_modal">
                <div className="modal-body">
                    {/* Header */}
                    <div className="modal_title">
                        <h2>Add Delivery Zone</h2>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => setOpen(false)}
                        >
                            <CloseIcon />
                        </button>
                    </div>

                    {/* Form */}
                    <form className="form">
                        <div className="gap_p">
                            {/* Zone Name */}
                            <div className="control_group w_50">
                                <label htmlFor="zone-name">Zone Name</label>
                                <TextField
                                    placeholder="Dubai Zone"
                                    fullWidth
                                    hiddenLabel
                                    inputProps={{ id: "zone-name" }}
                                />
                            </div>

                            {/* Code */}
                            <div className="control_group w_50">
                                <label htmlFor="zone-code">Code</label>
                                <TextField
                                    placeholder="DXB-01"
                                    fullWidth
                                    hiddenLabel
                                    inputProps={{ id: "zone-code" }}
                                />
                            </div>

                            {/* Zone Type */}
                            <div className="control_group">
                                <label htmlFor="zone-type">Zone Type</label>
                                <Select
                                    fullWidth
                                    value={zoneType}
                                    onChange={handleZoneTypeChange}
                                    inputProps={{ id: "zone-type" }}
                                >
                                    <MenuItem value="City">City</MenuItem>
                                    <MenuItem value="State">State</MenuItem>
                                    <MenuItem value="Country">Country</MenuItem>
                                </Select>
                            </div>

                            {/* Cities */}
                            <div className="control_group">
                                <label htmlFor="zone-cities">Cities (one per line)</label>
                                <TextField
                                    placeholder={`Dubai\nAbu Dhabi\nSharjah`}
                                    multiline
                                    rows={4}
                                    fullWidth
                                    hiddenLabel
                                    inputProps={{ id: "zone-cities" }}
                                />
                            </div>

                            {/* Min Delivery Time */}
                            <div className="control_group w_50">
                                <label htmlFor="min-delivery-time">Min Delivery Time</label>
                                <TextField
                                    placeholder="1"
                                    type="number"
                                    fullWidth
                                    hiddenLabel
                                    inputProps={{ id: "min-delivery-time" }}
                                />
                            </div>

                            {/* Max Delivery Time */}
                            <div className="control_group w_50">
                                <label htmlFor="max-delivery-time">Max Delivery Time</label>
                                <TextField
                                    placeholder="3"
                                    type="number"
                                    fullWidth
                                    hiddenLabel
                                    inputProps={{ id: "max-delivery-time" }}
                                />
                            </div>

                            {/* Unit */}
                            <div className="control_group w_50">
                                <label htmlFor="delivery-unit">Unit</label>
                                <Select
                                    fullWidth
                                    value={unit}
                                    onChange={handleUnitChange}
                                    inputProps={{ id: "delivery-unit" }}
                                >
                                    <MenuItem value="Days">Days</MenuItem>
                                    <MenuItem value="Hours">Hours</MenuItem>
                                </Select>
                            </div>

                            {/* Active */}
                            <div className="control_group">
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={active}
                                            onChange={(e) =>
                                                setActive(e.target.checked)
                                            }
                                        />
                                    }
                                    label="Active"
                                />
                            </div>
                        </div>
                        {/* Footer */}
                        <div className="footer_btn_flex">
                            <Button
                                className="btn btn_grey"
                                onClick={() => setOpen(false)}
                            >
                                Cancel
                            </Button>
                            <Button
                                className="btn btn_primary"
                                onClick={() => setOpen(false)}
                            >
                                Create
                            </Button>
                        </div>

                    </form>
                </div>
            </div>
        </Modal>
    );
}
